import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/Hooks';
import {
	fetchQuestionnaireResultsData,
	getQuestionnaireResultsData,
	getResultAPICompletionStatus,
} from '../../redux/QuestionnaireSpecificResultsSlice/QuestionnaireSpecificResultsResponseSlice';
import { IQuestionnaireDataRequest } from '../../types/SurveyProps';
import { fetchResponseGraphData } from '../../redux/QuestionnaireResultsSlice';
import { selectedFilterRequestPayloadData } from '../../redux/SurveySlice';
import { API_STATUS_CONSTANT } from '../../constants/StepConstants';
import Questions from './Questions';

const Main: React.FC<unknown> = () => {
	const QuestionnaireResultContainer = styled(Box)({
		background: '#F9F8F7',
		paddingTop: '20px',
		width: '100%',
	});
	const ResponseGraphContainers = styled(Box)({
		display: 'flex',
		padding: '20px',
		boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.06)',
		borderRadius: '12px',
		background: '#fff',
	});

	const dispatch = useAppDispatch();
	const questionsAnswers: IQuestionnaireDataRequest = useAppSelector(
		getQuestionnaireResultsData
	);
	const { questionnaireID } = useParams<{ questionnaireID: string }>();
	const filterRequestPayload = useAppSelector(selectedFilterRequestPayloadData);

	const includeFilters = JSON.parse(filterRequestPayload.includeFilters);
	const excludeFilters = JSON.parse(filterRequestPayload.excludeFilters);
	const includeFilterStr = JSON.stringify(includeFilters);
	const excludeFilterStr = JSON.stringify(excludeFilters);
	/**
	 * @useEffect
	 * @summary - Onpage load, collects questainnaire information
	 */
	useEffect(() => {
		questionnaireID && dispatch(fetchQuestionnaireResultsData(questionnaireID));
	}, [questionnaireID, dispatch]);

	useEffect(() => {
		const reqPayload = {
			questionnaireId: `${questionnaireID}`,
			includeFilter: JSON.stringify(includeFilters),
			excludeFilter: JSON.stringify(excludeFilters),
		};
		if (questionnaireID) {
			dispatch(fetchResponseGraphData(reqPayload));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [questionnaireID, includeFilterStr, excludeFilterStr]);

	const [isRefreshWorking, setIsRefreshWorking] = useState(false);
	const resultAPICompletionStatus = useAppSelector(
		getResultAPICompletionStatus
	);
	const handleRefresh = () => {
		setIsRefreshWorking(true);
		questionnaireID && dispatch(fetchQuestionnaireResultsData(questionnaireID));
	};
	useEffect(() => {
		const reqPayload = {
			questionnaireId: `${questionnaireID}`,
			includeFilter: JSON.stringify(includeFilters),
			excludeFilter: JSON.stringify(excludeFilters),
		};
		if (
			isRefreshWorking &&
			questionnaireID &&
			resultAPICompletionStatus === API_STATUS_CONSTANT.SUCCESS
		) {
			dispatch(fetchResponseGraphData(reqPayload));
			setIsRefreshWorking(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resultAPICompletionStatus, isRefreshWorking]);

	return questionsAnswers?.qAndA?.questionJSONString ? (
		<Box
			className="results-response-graph-container"
			data-testid="graph-container"
			sx={{ width: '100%' }}
		>
			<QuestionnaireResultContainer>
				<ResponseGraphContainers
					sx={{
						width: '98%',
						gap: '40px',
						overflow: 'hidden',
					}}
				>
					<Questions
						questionJSONString={questionsAnswers?.qAndA?.questionJSONString}
						handleRefresh={handleRefresh}
					/>
				</ResponseGraphContainers>
			</QuestionnaireResultContainer>
		</Box>
	) : (
		<></>
	);
};

export default Main;
